import styled from 'styled-components';

import {
  ArticleItemContainer,
  BasicItemContainer,
} from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/components/layout';
import { media } from '~/src/styles-constants';

export const EssentialsItemsContainer = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 100%;

  ${media.M`
    /* 8px = gap / 2 */
    grid-template-columns: calc(50% - 8px) calc(50% - 8px);
  `}
  padding: 16px;

  overflow: hidden;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.common.BACKGROUND_1};

  & > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
  }

  & > ${BasicItemContainer} {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const ArticleItemCellContainer = styled.div`
  position: relative;
  min-width: 0;
  gap: 8px;

  & > ${ArticleItemContainer} {
    /* 40px (picker) + 8px (margin) */
    max-width: calc(100% - 48px);
  }
`;

export const CartPickerContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`;
